import Diacritics from 'diacritic'

export function processQueryForSearch (query) {
  let processedQuery = ''
  if (query) {
    let queryTerms = query.split(/\s+/)

    for (var i = 0; i < queryTerms.length; i++) {
      let term = queryTerms[i]
      term = stripAccents(term)
      term = removeNonAlphaNumeric(term)
      term = term.toLowerCase()
      if (term) {
        processedQuery = processedQuery + formatTermForSearch(term)
      }
    }
  }
  return processedQuery
}

let stripAccents = function (term) {
  return Diacritics.clean(term)
}

let removeNonAlphaNumeric = function (term) {
  return term.replace(/\W/gi, '')
}

let formatTermForSearch = function (term) {
  return '+(/.*' + term + '.*/ || /.*' + term + '?.*/ || "' + term + '")'
}
